import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CountryListActions from './Countrylist.action';
import { NSAdminService } from '../../Clients/NS/Services/NSAdmin.service';

@Injectable()
export class CountryListEffects {
  constructor(
    private actions$: Actions,
    private adminService: NSAdminService
  ) {}

  loadCountryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryListActions.loadCountryList),
      mergeMap(() =>
        of(this.adminService.getCountryList()).pipe(
          map((countries) =>
            CountryListActions.loadCountryListSuccess({ countries })
          ),
          catchError((error) =>
            of(CountryListActions.loadCountryListFailure({ error }))
          )
        )
      )
    )
  );
}
